module.exports = __webpack_public_path__ + "media/images/dot-matrix-a57e00b64f60da6455f0d12bf9b57a93.svg";